import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MessageModel } from '../models/response.model';
import { escapeHtml } from '../helpers/html-escape';
import { sanitizeHtml } from '../helpers/html-sanitizer';

@Injectable({ providedIn: 'root'})
export class AlertService {

  constructor() { }

  /**
   * Swal title/html parametreleri innerHTML olarak basıldığından gelen içerik sanitize edilir.
   * <br>, <b>, <span style> gibi işaretlemeler korunur; script, event handler (onerror vb.)
   * ve javascript: URL'leri temizlenir. Bkz. `sanitizeHtml`.
   */
  private safeHtml(value: string): string {
    return sanitizeHtml(value);
  }

  showCustomMessage(messageTitle: string, message: string, iconType: SweetAlertIcon) {
    Swal.fire(this.safeHtml(messageTitle), this.safeHtml(message), iconType);
  }

  showSuccessMessage(message: string) {
    Swal.fire(this.safeHtml(message),'success');
  }
  showInfoMessage(message: string) {
    Swal.fire(this.safeHtml(message),'info');
  }
  showErrorMessage(message: string) {
    Swal.fire(this.safeHtml(message),'error');
  }

  showWarningMessage(message: string) {
    Swal.fire(this.safeHtml(message),'warning');
  }

  showOperationSuccessMessageNotification() {
    Swal.fire({
      position: 'top-end', icon: 'success', title: 'Success',
      showConfirmButton:false,timer:1500
    });
  }
  showOperationFailedMessageNotification() {
    Swal.fire({
      position: 'top-end', icon: 'error', title: 'Error',
      showConfirmButton: false,
      timer:1500
    });
  }

  showErrorMessageList(messages: MessageModel[]) {
    if (!messages || !messages.length) {
      return;
    }
    let messageHtml = '';
    messages.forEach(x => messageHtml += `${escapeHtml(x.Message)}<br>`);
    Swal.fire({
      title: 'Bir Hata Oluştu', icon: 'error', html: messageHtml,
      confirmButtonText:"Kapat"
    });
  }

}
